"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationPanel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const Pagination_1 = require("Views/Shared/Components/Pagination");
const context_1 = require("../context");
const PaginationPanel = () => {
    const { currentPage, totalPages, pageSize, refinePage, refinePageSize, setIsHitsLoading, setLastUserAction, dictionary, } = (0, context_1.useSearchResultContext)();
    const handlePageChange = (obj) => {
        setIsHitsLoading(true);
        refinePage(obj.selected);
        setLastUserAction({ name: app_1.LastUserActionNameEnum.Pagination, key: obj.selected.toString() });
        window.scrollTo({ top: 0 });
    };
    const handlePageSizeChange = (pageSize) => {
        setIsHitsLoading(true);
        refinePageSize(pageSize);
        setLastUserAction({ name: app_1.LastUserActionNameEnum.Pagination, key: pageSize.toString() });
        window.scrollTo({ top: 0 });
    };
    return ((0, jsx_runtime_1.jsx)(Pagination_1.default, { pageCount: totalPages, forcePage: currentPage, onPageChange: handlePageChange, pageSize: pageSize, onPageSizeChange: handlePageSizeChange, dictionary: dictionary }));
};
exports.PaginationPanel = PaginationPanel;
